import React from 'react';

/**
 * Catches render-time exceptions so a failure in one page shows a recoverable
 * message instead of a blank white screen.
 */
class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }

    static getDerivedStateFromError() {
        return { hasError: true };
    }

    componentDidCatch(error, errorInfo) {
        console.error('Unhandled rendering error:', error, errorInfo);
    }

    render() {
        if (!this.state.hasError) {
            return this.props.children;
        }

        return (
            <div className="flex min-h-screen items-center justify-center bg-[#f8fafc] px-4">
                <div className="w-full max-w-md rounded-lg border border-gray-200 bg-white p-8 text-center shadow-sm">
                    <h1 className="mb-2 text-lg font-semibold text-[#0f172a]">
                        Something went wrong
                    </h1>
                    <p className="mb-6 text-sm leading-relaxed text-gray-600">
                        This page could not be displayed. Your data has not been changed.
                        Try reloading, or go back to your portfolios.
                    </p>
                    <div className="flex justify-center gap-3">
                        <button
                            type="button"
                            onClick={() => window.location.reload()}
                            className="rounded-md bg-[#0f172a] px-4 py-2 text-sm font-medium text-white hover:opacity-90"
                        >
                            Reload page
                        </button>
                        <button
                            type="button"
                            onClick={() => { window.location.href = '/'; }}
                            className="rounded-md border border-gray-300 px-4 py-2 text-sm font-medium text-[#0f172a] hover:bg-gray-50"
                        >
                            Go to portfolios
                        </button>
                    </div>
                </div>
            </div>
        );
    }
}

export default ErrorBoundary;
